import SynonymsLocation from "@/assets/icons/SynonymsLocation.svg?react";

export const Modules = {
  cpiPrototype: "cpiPrototype",
  v2_jobs: "myjobs",
  v2_add_synonyms_jobs: "v2_add_synonyms_jobs",
  v2_add_synonyms_job_title_group: "v2_add_synonyms_job_title_group",
  v2_job_title_group: "v2_job_title_group",
  v2_job_title_group_titles: "v2_job_title_group_titles",
  v2_add_synonyms: "v2_add_synonyms",
  v2_set_online: "v2_set_online",
  v2_set_pause: "v2_set_pause",
  v2_adjust_budget: "v2_adjust_budget",
  v2_adjust_budget_final: "v2_adjust_budget_final",
  v2_edit_custom_dimensions: "v2_edit_custom_dimensions",
  v2_export: "v2_export",
  v2_global: "v2_global",
  v2_tickets: "v2_tickets",
  v2_ssb: "v2_ssb",
  v2_ticket_admin: "v2_ticket_admin",
};

export const JobsPreferenceKeys = {
  competition: "MDCompetition",
  marketdata: "MDPreferences",
  recommendations: "Recommendations",
  addPostings: "AddPostings",
};

export const Columns = {
  titleIcon: { name: "titleIcon" },
  title: { name: "titleCol", label: "jobs_page_job_table_header_jobtitle_text", module: Modules.v2_jobs },
  checkBox: { name: "checkBoxCol", label: "v2_overview_location_label", module: Modules.v2_jobs },

  status: { name: "statusCol", label: "v2_add_synonyms_status_label", module: Modules.v2_jobs },
  ticketStatus: { name: "ticketStatusCol", label: "v2_overview_ticket_status_label", module: Modules.v2_jobs },

  location: {
    name: "locationCol",
    label: "v2_overview_location_label",
    icon: <SynonymsLocation />,
    module: Modules.v2_jobs,
  },
  synonymslocation: {
    name: "locationCol",
    label: "v2_overview_location_label",
    icon: <SynonymsLocation />,
    module: Modules.v2_jobs,
  },
  locationWithViewLocationSynonyms: {
    name: "locationWithViewLocationSynonymsCol",
    label: "v2_overview_location_label",
    icon: <SynonymsLocation />,
    module: Modules.v2_jobs,
  },
  // sourcing: {
  //   name: "sourcingCol",
  //   label: "v2_overview_sourcing_label",
  //   module: Modules.v2_jobs,
  // },
  customDimensions: { name: "cdCol", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use
  cd1: { name: "cd1Col", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use
  cd2: { name: "cd2Col", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use
  cd3: { name: "cd3Col", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use
  cd4: { name: "cd4Col", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use
  cd5: { name: "cd5Col", label: "v2_overview_custom_dimensions_label", module: Modules.v2_jobs }, // Not in use

  onlineOfflineAndDaysOnline: {
    name: "onlineOfflineCol",
    label: "v2_overview_online_offline_label",
    module: Modules.v2_jobs,
    online_label: "v2_overview_days_online_label",
    online_pause_label: "v2_overview_days_pause_label",
    online_offline_label: "v2_overview_days_offline_label",
  },
  onlineOffline: {
    name: "onlineOfflineColSynonyms",
    label: "v2_synonyms_online_label",
    module: Modules.v2_jobs,
  },

  totalClickAndTotalSpentBudgetEntireLifetime: {
    name: "campaignClickAndTotalClicksCol",
    label: "v2_overview_campaign_total_clicks_label",
    module: Modules.v2_jobs,
  },

  clicksBudgetSpentLast30days: {
    name: "clicksLast30daysCol",
    label: "v2_overview_clicks_last_30_days_label",
    module: Modules.v2_jobs,
  },
  totalSpentBudgetAndMaxJobBudget: {
    name: "totalSpentBudgetAndMaxJobBudgetCol",
    label: "v2_overview_total_max_budget_label",
    module: Modules.v2_jobs,
  },
  budgetSpentInTheSelectedPeriod: {
    name: "budgetSpentInTheSelectedPeriodCol",
    label: "v2_overview_budget_spent_in_selected_period_label",
    module: Modules.v2_jobs,
  },

  startAppAndRate: {
    name: "startAppAndRateCol",
    label: "v2_overview_start_app_and_rate_label",
    module: Modules.v2_jobs,
  },
  endAppAndRate: { name: "endAppAndRateCol", label: "v2_overview_end_app_and_rate_label", module: Modules.v2_jobs },
  costPerApplication: {
    name: "costPerApplicationCol",
    label: "v2_overview_cost_per_application_label",
    module: Modules.v2_jobs,
  },

  marketData: {
    name: "marketDataCol",
    label: "v2_overview_marketdata_label",
    label2: "v2_campaign_marketdata_heading",
    module: Modules.v2_jobs,
  },
  jqx: { name: "JQXCol", label: "v2_overview_jqx_label", module: Modules.v2_jobs },
  synonyms: { name: "synonymsCol", label: "v2_overview_synonyms_label", module: Modules.v2_jobs },

  vacancy: { name: "vacancyCol", label: "v2_overview_vacancy_label", module: Modules.v2_jobs },
  factor: { name: "factorCol", label: "v2_overview_factor_label", module: Modules.v2_jobs },

  synonymsType: { name: "synonymsTypeCol", label: "v2_overview_synonyms_type_label", module: Modules.v2_jobs },

  clickAndBudget: { name: "clicksAndBudgetCol", label: "v2_overview_clicks_budget_label", module: Modules.v2_jobs },

  startEndApp: { name: "startEndAppCol", label: "v2_overview_start_end_app_label", module: Modules.v2_jobs },

  // JTC Page
  jtcTitle: { name: "jtctitleCol", label: "jqx_pg_table_group_heading", module: Modules.v2_job_title_group },
  jtcCategory: { name: "jtcCategoryCol", label: "category_text", module: Modules.v2_job_title_group },
  jtcJobCount: { name: "jtcJobCountCol", label: "jqx_pg_table_jqx_count_heading", module: Modules.v2_job_title_group },
  jtcAvgJQX: { name: "jtcAvgJQXCol", label: "jqx_pg_header_avg_jqx_score", module: Modules.v2_job_title_group },
  jtcLastUpdate: { name: "jtcLastUpdateCol", label: "jqx_pg_last_update", module: Modules.v2_job_title_group },

  // JTC Level 2
  jtcLevel2Title: {
    name: "jtcLevel2TitleCol",
    label: "jobs_page_job_table_header_jobtitle_text",
    module: Modules.v2_job_title_group_titles,
  },
  jtcLevel2JQXScore: {
    name: "jqxScoreCol",
    label: "jobs_page_job_table_header_jqx_text",
    module: Modules.v2_job_title_group_titles,
  },
  jtcLevel2UsedAsSynonym: {
    name: "usedAsSynonymCol",
    label: "used_as_synonym_text",
    module: Modules.v2_job_title_group_titles,
  },
  jtcLevel2ClicksPerWeek: {
    name: "clicksCol",
    label: "clicks_per_week_text",
    module: Modules.v2_job_title_group_titles,
  },
  jtcLevel2CreationDate: {
    name: "creationDateCol",
    label: "jqx_pg_header_create_time",
    module: Modules.v2_job_title_group_titles,
  },

  // JTC Add Synonyms Page
  jtcTitleAddSynonyms: {
    name: "jtctitleColAdd",
    label: "jqx_pg_table_group_heading",
    module: Modules.v2_job_title_group,
  },

  jtcLevel2TitleAddSynonyms: {
    name: "jtcLevel2TitleAddSynonymsCol",
    label: "jobs_page_job_table_header_jobtitle_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },
  jtcLevel2JQXScoreAddSynonyms: {
    name: "jtcLevel2JQXScoreAddSynonymsCol",
    label: "mjclone_jqx_head_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },
  jtcAvgJQXAddSynonyms: {
    name: "jtcAvgJQXAddSynonymsCol",
    label: "mjclone_jqx_head_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },
  directlyPublished: {
    name: "directlyPublishedCol",
    label: "mj_direct_synonyms_head_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },

  // Jobs Add Synonyms Modal
  jobTitleAddSynonyms: {
    name: "jobTitleAddSynonyms",
    label: "jobs_page_job_table_header_jobtitle_text",
    module: Modules.v2_add_synonyms_jobs,
  },
  jobJQXScore: {
    name: "jobJQXScoreCol",
    label: "mjclone_jqx_head_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },
  jobsDirectlyPublished: {
    name: "jobDirectlyPublishedCol",
    label: "mj_direct_synonyms_head_text",
    module: Modules.v2_add_synonyms_job_title_group,
  },

  jobNewStatusSetOnline: {
    name: "jobNewStatusSetOnlineCol",
    label: "v2_new_status",
    module: Modules.v2_set_online,
  },

  jobNewStatusSetPause: {
    name: "jobNewStatusSetPauseCol",
    label: "v2_new_status",
    module: Modules.v2_set_pause,
  },

  jobAdjustBudgetSetOnline: {
    name: "jobAdjustBudgetSetOnlineCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_set_online,
  },

  jobSpentMaxBudget: {
    name: "jobSpentMaxBudgetCol",
    label: "pf_spent_max_job_budget_head",
    module: Modules.v2_set_online,
  },

  jobPauseAdjust: {
    name: "jobPauseAdjustCol",
    label: "pf_th_raise_limit",
    module: Modules.v2_set_online,
  },

  jobNewBudgetSetOnline: {
    name: "jobNewBudgetSetOnlineCol",
    label: "pf_new_budget_raise_text",
    module: Modules.v2_set_online,
  },

  serialColNumber: { name: "serialColNumber", label: "jqx_pg_preview_sno", module: Modules.v2_set_online },

  serialCol: { name: "serialCol", label: "#", module: Modules.v2_add_synonyms_jobs },
  jobTitleEditCD: {
    name: "jobTitleEditCD",
    label: "jobs_page_job_table_header_jobtitle_text",
    module: Modules.v2_add_synonyms_jobs,
  },
  editCDField: {
    name: "editCDFieldCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_edit_custom_dimensions,
  },

  dateOfRequestTicket: {
    name: "dateOfRequestTicketCol",
    label: "jqx_pg_preview_sno",
    module: Modules.v2_tickets,
  },
  TicketName: {
    name: "TicketNameCol",
    label: "mjclone_reject_titleCol_text",
    module: Modules.v2_tickets,
  },
  TicketLocation: {
    name: "TicketLocationCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_tickets,
  },
  statusTicket: {
    name: "statusTicketCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_tickets,
  },
  lastUpdatedTicket: {
    name: "lastUpdatedTicketCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_tickets,
  },
  ticketAction: {
    name: "ticketActionCol",
    label: "v2_new_adjust_budget",
    module: Modules.v2_tickets,
  },
  // For SSB Page Dropdown
  offlineDate: {
    name: "offlineDate",
    label: "v2_sort_offlineDate_label",
    module: Modules.v2_jobs,
  },
  daysOnline: {
    name: "daysOnline",
    label: "v2_sort_daysOnline_label",
    module: Modules.v2_jobs,
  },
};

export const FiltersConstants = {
  newDateRangePicker: {
    name: "newDateRangePicker",
    label: "v2_filter_label_date_range",
    module: Modules.v2_jobs,
    fromToLabels: { from_date: "v2_filter_label_from_date", to_date: "v2_filter_label_to_date" },

    displayLabel: false,
    // tagPostFix: 'Date',
  },
  recentJobs: {
    name: "recentJobs",
    label: "v2_filter_label_newJobs",
    module: Modules.v2_jobs,
    checkBoxLabels: { recentJobs: "v2_filter_check_label_newJobs" },
  },
  jobStatus: {
    name: "jobStatus",
    label: "v2_filter_label_job_status",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      online: "v2_filter_check_label_online",
      paused: "v2_filter_check_label_paused",
      offline: "v2_filter_check_label_offline",
    },
  },
  todos: {
    name: "todos",
    label: "v2_filter_label_todos",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      improveJQX: "v2_filter_check_label_improveJQX",
      addSynonyms: "v2_filter_check_label_addSynonyms",
      increaseBudget: "v2_filter_check_label_increaseBudget",
      budgetLimitReached: "v2_filter_check_label_budgetLimitReached",
    },
  },

  location: {
    name: "location",
    label: "v2_filter_label_location",
    module: Modules.v2_jobs,
    apiAction: "getLocations",
    reset_label: "v2_reset_location",
  },
  locationMultiSelect: {
    name: "locationMultiSelect",
    label: "v2_filter_label_location",
    module: Modules.v2_jobs,
    apiAction: "getLocations",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_location",
    displayLabel: false,
  },
  cd1MultiSelect: {
    name: "cd1MultiSelect",
    label: "",
    module: Modules.v2_jobs,
    apiAction: "getCustomDimensions",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_cd",
    type: "cd1",
  },
  cd2MultiSelect: {
    name: "cd2MultiSelect",
    label: "",
    module: Modules.v2_jobs,
    apiAction: "getCustomDimensions",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_cd",
    type: "cd2",
  },
  cd3MultiSelect: {
    name: "cd3MultiSelect",
    label: "",
    module: Modules.v2_jobs,
    apiAction: "getCustomDimensions",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_cd",
    type: "cd3",
  },
  cd4MultiSelect: {
    name: "cd4MultiSelect",
    label: "",
    module: Modules.v2_jobs,
    apiAction: "getCustomDimensions",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_cd",
    type: "cd4",
  },
  cd5MultiSelect: {
    name: "cd5MultiSelect",
    label: "",
    module: Modules.v2_jobs,
    apiAction: "getCustomDimensions",
    enableFiltersTagBottom: true,
    reset_label: "v2_reset_cd",
    type: "cd5",
  },

  customDimensions: {
    name: "customDimensions",
    label: "v2_filter_label_customDimensions",
    module: Modules.v2_jobs,
  },

  titleJQX: {
    name: "titleJQX",
    label: "v2_filter_label_titleJQX",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      expansiveImprovementJQX: "v2_filter_check_label_expansiveImprovementJQX",
      actionNeededJQX: "v2_filter_check_label_actionNeededJQX",
      improvementPossibleJQX: "v2_filter_check_label_improvementPossibleJQX",
      perfectJQX: "v2_filter_check_label_perfectJQX",
    },
    displayLabel: false,
  },

  vacancyMD: {
    name: "vacancyMD",
    label: "v2_filter_label_vacancyMD",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      veryHighVacancyTime: "v2_filter_check_label_veryHighVacancyTime",
      highVacancyTime: "v2_filter_check_label_highVacancyTime",
      lowVacancyTime: "v2_filter_check_label_lowVacancyTime",
    },
  },
  factorMD: {
    name: "factorMD",
    label: "v2_filter_label_factorMD",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      highShortageLabor: "v2_filter_check_label_highShortageLabor",
      shortageLabor: "v2_filter_check_label_shortageLabor",
      noShortageLabor: "v2_filter_check_label_noShortageLabor",
    },
  },

  // TODO: later

  ticketStatus: {
    name: "ticketStatus",
    label: "v2_filter_label_ticket_status",
    module: Modules.v2_jobs,
    checkBoxLabels: {
      inProgress: "v2_filter_check_label_inProgress",
      inReview: "v2_filter_check_label_inReview",
      noTickets: "v2_filter_check_label_noTickets",
    },
  },

  // raiseBudgetRecommendation:{
  //   name:'raiseBudgetRecommendation',
  //   label:('mj_filter_raiseBudgetRecommendation_label'),
  //   module:Modules.v2_jobs
  // },

  customDimensionsCombined: {
    name: "customDimensionsCombined",
    label: "v2_sort_custom_dimensions_label",
    module: Modules.v2_jobs,
  },

  synonymsRange: {
    name: "synonymsRange",
    label: "v2_filter_label_synonyms_range",
    module: Modules.v2_jobs,
    fromToLabels: { synonymsFrom: "v2_filter_label_synonymsFrom", synonymsTo: "v2_filter_label_synonymsTo" },
    tagPostFix: "v2_filter_label_synonyms_range_postfix",
  },

  ClicksRange: {
    name: "ClicksRange",
    label: "v2_filter_label_clicks_range",
    module: Modules.v2_jobs,
    fromToLabels: { clicksFrom: "v2_filter_label_clicksFrom", clicksTo: "v2_filter_label_clicksTo" },
    tagPostFix: "v2_filter_label_clicks_range_postfix",
  },

  CostPerApplicationRange: {
    name: "CostPerApplicationRange",
    label: "v2_filter_label_costPerApplication_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      costPerApplicationFrom: "v2_filter_label_costPerApplicationFrom",
      costPerApplicationTo: "v2_filter_label_costPerApplicationTo",
    },
    tagPostFix: "v2_filter_label_costPerApplication_range_postfix",
  },
  StartApplicationRange: {
    name: "StartApplicationRange",
    label: "v2_filter_label_StartApplication_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      StartApplicationFrom: "v2_filter_label_StartApplicationFrom",
      StartApplicationTo: "v2_filter_label_StartApplicationTo",
    },
    tagPostFix: "v2_filter_label_StartApplication_range_postfix",
  },
  SendApplicationRange: {
    name: "SendApplicationRange",
    label: "v2_filter_label_SendApplication_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      SendApplicationFrom: "v2_filter_label_SendApplicationFrom",
      SendApplicationTo: "v2_filter_label_SendApplicationTo",
    },
    tagPostFix: "v2_filter_label_SendApplication_range_postfix",
  },
  StartApplicationRateRange: {
    name: "StartApplicationRateRange",
    label: "v2_filter_label_StartApplicationRate_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      StartApplicationRateFrom: "v2_filter_label_StartApplicationRateFrom",
      StartApplicationRateTo: "v2_filter_label_StartApplicationRateTo",
    },
    tagPostFix: "v2_filter_label_StartApplicationRate_range_postfix",
  },
  SendApplicationRateRange: {
    name: "SendApplicationRateRange",
    label: "v2_filter_label_SendApplicationRate_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      SendApplicationRateFrom: "v2_filter_label_SendApplicationRateFrom",
      SendApplicationRateTo: "v2_filter_label_SendApplicationRateTo",
    },
    tagPostFix: "v2_filter_label_SendApplicationRate_range_postfix",
  },

  BudgetInTheSelectedPeriodRange: {
    name: "BudgetInTheSelectedPeriodRange",
    label: "v2_filter_label_BudgetInTheSelectedPeriod_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      BudgetInTheSelectedPeriodFrom: "v2_filter_label_BudgetInTheSelectedPeriodFrom",
      BudgetInTheSelectedPeriodTo: "v2_filter_label_BudgetInTheSelectedPeriodTo",
    },
    tagPostFix: "v2_filter_label_BudgetInTheSelectedPeriod_range_postfix",
  },
  BudgetInTheTotalLifetimeRange: {
    name: "BudgetInTheTotalLifetimeRange",
    label: "v2_filter_label_BudgetInTheTotalLifetime_range",
    module: Modules.v2_jobs,
    fromToLabels: {
      BudgetInTheTotalLifetimeFrom: "v2_filter_label_BudgetInTheTotalLifetimeFrom",
      BudgetInTheTotalLifetimeTo: "v2_filter_label_BudgetInTheTotalLifetimeTo",
    },
    tagPostFix: "v2_filter_label_BudgetInTheTotalLifetime_range_postfix",
  },

  sourcingSuitable: {
    name: "sourcingSuitable",
    label: "v2_filter_sourcing_title",
    module: Modules.v2_ssb,
    checkBoxLabels: {
      sourcingRecommended: "v2_filter_ssb_white_jobs",
      sourcingNotRecommended: "v2_filter_ssb_blue_jobs",
    },
  },

  TicketPriority: {
    name: "TicketPriority",
    label: "v2_filter_label_priority",
    module: "v2_ticket_admin",
    checkBoxLabels: {
      Urgent: "v2_filter_check_label_Urgent",
      High: "v2_filter_check_label_High",
      Medium: "v2_filter_check_label_Medium",
      hold: "v2_filter_check_label_hold",
      Low: "v2_filter_check_label_Low",
    },
  },
  TicketStatus: {
    name: "TicketStatus",
    label: "Ticket Status",
    module: "v2_ticket_admin",
    checkBoxLabels: {
      New: "Customer Request",
      // RepliedByUser: "Customer Request (Again)",
      RepliedByAdmin: "Replied By CC",
      Done: "Closed",
    },
  },
  TicketLocked: {
    name: "TicketLocked",
    label: "Ticket Locked",
    module: "v2_ticket_admin",
    checkBoxLabels: {
      lockedByMe: "Locked By Me",
      // RepliedByUser: "Customer Request (Again)",
      lockedByOthers: "Locked By Others",
      unlocked: "Not Locked",
    },
  },
  TicketAutomatic: {
    name: "TicketAutomatic",
    label: "Other Filters",
    module: "v2_ticket_admin",
    checkBoxLabels: {
      AutomaticApproval: "Hide Directly Publish Requests",
      DevTestAccount: "Show Test Accounts",
    },
  },
  // TicketTestAccount: {
  //   name: "TicketTestAccount",
  //   label: "Ticket TestAccount",
  //   module: "v2_ticket_admin",
  //   checkBoxLabels: {
      
  //   },
  // },

  TicketCustomers: {
    name: "TicketCustomers",
    label: "Customer",
    module: "v2_ticket_admin",
    apiAction: "getCustomers",
    reset_label: "v2_reset_customers",
  },

  
};

/** the tabs at the overview, copied out from the component */
export const allTabsConfig = [
  { key: "ToDos", label: "v2_jobs_tabs_head_1" },
  { key: "JobStatus", label: "v2_jobs_tabs_head_2" },
  { key: "JobApplications", label: "v2_jobs_tabs_head_3" },
  { key: "JobBudget", label: "v2_jobs_tabs_head_4" },
  { key: "Synonyms", label: "v2_jobs_tabs_head_5" },
  { key: "Jqx", label: "v2_jobs_tabs_head_6" },
  //{ key: "Sourcing", label: "v2_jobs_tabs_head_7" },
  { key: "MarketData", label: "v2_overview_marketdata_label" },
];

export const JobsTopbar = {
  JobsTab: {
    ToDos: "ToDos",
    JobStatus: "JobStatus",
    JobApplications: "JobApplications",
    JobBudget: "JobBudget",
    Synonyms: "Synonyms",
    Jqx: "Jqx",
    //Sourcing: "Sourcing",
    MarketData: "MarketData",
  },
  JobsTabConfig: {
    ToDos: "todos",
    JobStatus: "jobStatusTab",
    JobApplications: "conversionTab",
    JobBudget: "budgetTab",
    Synonyms: "synonymsTab",
    Jqx: "jqxTab",
    //Sourcing: "sourcingTab",
    MarketData: "marketDataTab",
  },
  // JobsConfigOverviewPage :{
  //   // ToDos: "todos",
  //   JobStatus: "jobStatusTab",
  //   JobApplications: "conversionTab",
  //   // JobBudget: "budgetTab",
  //   Synonyms: "synonymsTab",
  //   Jqx: "jqxTab",
  //   MarketData: "marketDataTab"
  // },
  JobsConfigOverviewPage: {
    JobStatus: {
      dataKey: "jobStatusTab",
      heading: "v2_campaign_job_status_heading",
      subheading: "Im ausgewählten Zeitraum beinhaltete deine Kampagne11 #JOBS_COUNT# - davon sind aktuell:",
    },
    JobApplications: {
      dataKey: "conversionTab",
      // heading: "Conversion (Daten ab 01.01.2022)",
    },
    Synonyms: {
      dataKey: "synonymsTab",
      heading: "v2_campaign_synonyms_heading",
    },
    Jqx: {
      dataKey: "jqxTab",
      heading: "v2_campaign_jqx_heading",
    },
    MarketData: {
      dataKey: "marketDataTab",
      heading: "v2_campaign_marketdata_heading",
    },
  },
  ToDos: [
    {
      title: "v2_add_synonyms",
      badge2_text: "addSynonymsNewJobs",
      badge_text: "addSynonyms",
      type: "ac-primary-md",
      badge2: "badge_p100",
      badge: "badge_s20",
      onClick: "addSynonyms",
      // tooltip: "v2_close_to_budget_tooltip_text",
      // tooltip2: "v2_out_of_budget_tooltip_text",
    },
    {
      title: "v2_jobs_summary_improve_job_title_quality_text",
      badge_text: "improveJQX",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "improveJQX",
    },
    {
      title: "v2_jobs_summary_increase_job_budget_text",
      badge_text: "increaseJobBudget",
      badge2_text: "BudgetLimitDepleted",
      type: "ac-primary-md",
      badge: "badge_y20",
      badge2: "badge_r20",
      onClick: "increaseJobBudget",
      tooltip: "v2_close_to_budget_tooltip_text",
      tooltip2: "v2_out_of_budget_tooltip_text",
    },
    {
      title: "v2_jobs_summary_job_is_on_track_text",
      badge_text: "jobsOnTrack",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "jobsOnTrack",
    },
  ],
  TabRecommendationsForPage: {
    addSynonyms: {
      title: "v2_add_synonyms",
      badge_text: "addSynonyms",
      type: "ac-primary-sm",
      badge: "badge_s20",
      onClick: "addSynonyms",
    },
    improveJQX: {
      title: "v2_jobs_summary_improve_job_title_quality_text",
      badge_text: "improveJQX",
      type: "ac-primary-sm",
      badge: "badge_s20",
      onClick: "improveJQX",
    },
    increaseJobBudget: {
      title: "v2_jobs_summary_increase_job_budget_text",
      badge_text: "increaseJobBudget",
      type: "ac-primary-sm",
      badge: "badge_s20",
      onClick: "increaseBudget",
    },
  },

  JobStatus: [
    {
      title: "v2_online",
      badge_text: "online",
      type: "ac-primary-md online",
      badge: "badge_g20",
      onClick: "online",
    },
    {
      title: "v2_paused",
      badge_text: "paused",
      type: "ac-primary-md paused",
      badge: "badge_y20",
      onClick: "paused",
    },
    {
      title: "v2_offline",
      badge_text: "offline",
      type: "ac-primary-md offline",
      badge: "badge_r20",
      onClick: "offline",
    },
  ],

  JobApplications: [
    {
      title: "v2_jobs_summary_without_applications",
      badge_text: "withoutApplications",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "withoutApplications",
    },
    {
      title: "v2_jobs_summary_with_applications",
      badge_text: "withApplications",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "withApplications",
    },
  ],

  JobBudget: [
    {
      title: "v2_jobs_summary_budget_out_and_paused",
      badge_text: "budgetLimitReached",
      type: "ac-primary-md",
      badge: "badge_r20",
      onClick: "budgetLimitReached",
    },
    {
      title: "v2_jobs_summary_budget_close_to",
      badge_text: "budgetUsedMoreThan90Percent",
      type: "ac-primary-md",
      badge: "badge_y20",
      onClick: "budgetUsedMoreThan90Percent",
    },
    {
      title: "v2_jobs_summary_budget_within",
      badge_text: "budgetUsedBelow90Percent",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "budgetUsedBelow90Percent",
    },
  ],

  Synonyms: [
    {
      title: "v2_online",
      badge_text: "SynonymsOnline",
      type: "ac-green-md online",
      badge: "badge_g20",
      header: true,
    },
    {
      title: "v2_paused",
      badge_text: "SynonymsPaused",
      type: "ac-yellow-md paused",
      badge: "badge_y20",
      header: true,
    },
    {
      title: "v2_offline",
      badge_text: "SynonymsOffline",
      type: "ac-red-md offline",
      badge: "badge_r20",
      header: true,
    },
    {
      title: "v2_jobs_summary_synonyms_review",
      badge_text: "JobsWithTicketPending",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "JobsWithTicketPending",
    },

    {
      title: "v2_jobs_summary_synonyms_can_have_more",
      badge_text: "JobsCanHaveMoreSynonyms",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "JobsCanHaveMoreSynonyms",
    },
    {
      title: "v2_jobs_summary_synonyms_progress",
      badge_text: "JobsWithTicketInProgess",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "JobsWithTicketInProgess",
    },
    {
      title: "v2_jobs_summary_synonyms_have_enough",
      badge_text: "JobsAlreadyHaveEnoughSynonyms",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "JobsAlreadyHaveEnoughSynonyms",
    },
    {
      title: "v2_jobs_summary_synonyms_review_new",
      badge_text: "JobsWithTicketPending",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "JobsWithTicketPending",
    },
    {
      title: "v2_jobs_summary_synonyms_progress_new",
      badge_text: "JobsWithTicketInProgess",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "JobsWithTicketInProgess",
    },
  ],

  Jqx: [
    {
      title: "v2_jobs_summary_jqx_avg",
      badge_text: "avgJQX",
      type: "ac-yellow-md",
      badge: "badge_y20",
      onClick: "noFilter",
    },
    {
      title: "v2_jobs_summary_jqx_avg_syn",
      badge_text: "avgSynonymJobs",
      type: "ac-secondary-md",
      badge: "badge_s20",
      onClick: "noFilter",
    },
    {
      title: "v2_jobs_summary_jqx_expan_imp",
      badge_text: "expansiveImprovementJQX",
      type: "ac-primary-md",
      badge: "badge_r20",
      onClick: "expansiveImprovementJQX",
    },
    {
      title: "v2_jobs_summary_jqx_action_needed",
      badge_text: "actionNeededJQX",
      type: "ac-primary-md",
      badge: "badge_y20",
      onClick: "actionNeededJQX",
    },

    {
      title: "v2_jobs_summary_jqx_possible_imp",
      badge_text: "improvementPossibleJQX",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "improvementPossibleJQX",
    },
    {
      title: "v2_jobs_summary_jqx_perfect",
      badge_text: "perfectJQX",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "perfectJQX",
    },
  ],

  JTC: [
    {
      title: "v2_jobs_summary_jqx_avg",
      badge_text: "avgJQX",
      type: "ac-yellow-md",
      badge: "badge_y20",
      onClick: "noFilter",
    },
    {
      title: "v2_jobs_summary_jqx_expan_imp",
      badge_text: "expansiveImprovementJQX",
      type: "ac-primary-md",
      badge: "badge_r20",
      onClick: "expansiveImprovementJQX",
    },
    {
      title: "v2_jobs_summary_jqx_action_needed",
      badge_text: "actionNeededJQX",
      type: "ac-primary-md",
      badge: "badge_y20",
      onClick: "actionNeededJQX",
    },
    {
      title: "v2_jobs_summary_jqx_avg_syn",
      badge_text: "avgSynonymJobs",
      type: "ac-secondary-md",
      badge: "badge_s20",
      onClick: "noFilter",
    },
    {
      title: "v2_jobs_summary_jqx_possible_imp",
      badge_text: "improvementPossibleJQX",
      type: "ac-primary-md",
      badge: "badge_s20",
      onClick: "improvementPossibleJQX",
    },
    {
      title: "v2_jobs_summary_jqx_perfect",
      badge_text: "perfectJQX",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "perfectJQX",
    },
  ],
  MarketData: [
    {
      title: "v2_mm_vacancy_main_tab",
      badge_text: "avgVacancy",
      type: "ac-yellow-md",
      badge: "badge_y20",
      onClick: "noFilter",
    },
    {
      title: "v2_md_legend_vacancy_very_high",
      sub_title: "v2_mm_vacancy_more_than_30_text",
      badge_text: "totalSignifincantHighVacany",
      type: "ac-primary-md",
      badge: "badge_r20",
      onClick: "totalSignifincantHighVacany",
    },
    {
      title: "v2_md_legend_vacancy_high",
      sub_title: "v2_mm_vacancy_between_1_and_30_text",
      badge_text: "totalModerateHighVacany",
      type: "ac-primary-md",
      badge: "badge_y20",
      onClick: "totalModerateHighVacany",
    },
    {
      title: "v2_md_legend_vacancy_low",
      sub_title: "v2_md_below_ref_time",
      badge_text: "totalBelowAvgVacany",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "totalBelowAvgVacany",
    },

    {
      title: "v2_mm_factor_main_tab",
      badge_text: "avgFactor",
      type: "ac-green-md",
      badge: "badge_g20",
      onClick: "noFilter",
    },
    {
      title: "v2_md_legend_labour_high_shortage",
      sub_title: "v2_mm_factor_less_than_equal_1_text",
      badge_text: "totalHighShortageFactor",
      type: "ac-primary-md",
      badge: "badge_r20",
      onClick: "totalHighShortageFactor",
    },
    {
      title: "v2_md_legend_labour_shortage",
      sub_title: "v2_mm_factor_between_1_and_3_text",
      badge_text: "totalShortageFactor",
      type: "ac-primary-md",
      badge: "badge_y20",
      onClick: "totalShortageFactor",
    },
    {
      title: "v2_md_legend_labour_no_shortage",
      sub_title: "v2_mm_factor_more_than_3_text",
      badge_text: "totalNoShortageFactor",
      type: "ac-primary-md",
      badge: "badge_g20",
      onClick: "totalNoShortageFactor",
    },
  ],
  // Sourcing: [
  //   {
  //     title: "v2_jobs_summary_sourcing_recommended",
  //     badge_text: "JobsWithSourcingRecommended",
  //     type: "ac-primary-md",
  //     badge: "badge_g20",
  //     onClick: "JobsWithSourcingRecommended",
  //   },
  //   {
  //     title: "v2_jobs_summary_sourcing_not_recommended",
  //     badge_text: "JobsWithSourcingNotRecommended",
  //     type: "ac-primary-md",
  //     badge: "badge_y20",
  //     onClick: "JobsWithSourcingNotRecommended",
  //   },
  //   {
  //     title: "v2_jobs_summary_sourcing_started",
  //     badge_text: "JobsWithSourcingStarted",
  //     type: "ac-primary-md",
  //     badge: "badge_s20",
  //     onClick: "JobsWithSourcingStarted",
  //   },
  // ],
};

// const viewsOverviewOptions = ["v2_views_favorite", "v2_views_my", "v2_views_others", "v2_views_all"];
// lesser the priority, higher the order
export const viewsOverviewTabOptions = [
  {
    key: "favorite",
    label: "v2_favorites",
    showCount: true,
    priority: 1,
  },
  {
    key: "my",
    label: "v2_my_views",
    showCount: true,
    priority: 2,
  },
  {
    key: "others",
    label: "v2_other_views",
    showCount: true,
    priority: 4,
  },
  {
    key: "all",
    label: "v2_all_views",
    showCount: true,
    priority: 3,
  },
];

export const SortGroups = {
  Jobs: {
    // newlyAdded: {
    //   label: 'v2_jobs_summary_newly_added_text',
    //   key : 'newlyAdded'

    // },
    basicData: {
      label: "v2_sort_basic_label",
      key: "basicData",
      childs: [
        {
          label: "v2_sort_job_title_label",
          key: "title",
        },
        {
          label: "v2_sort_jobStatus_label",
          key: "jobStatus",
        },
        {
          label: "v2_sort_location_label",
          key: "location",
        },
        {
          label: "v2_sort_onlineDate_label",
          key: "onlineDate",
        },
        // {
        //   label: 'v2_sort_PauseDate_label',
        //   key : 'PauseDate'
        // },
        {
          label: "v2_sort_offlineDate_label",
          key: "offlineDate",
        },
        {
          label: "v2_sort_daysOnline_label",
          key: "daysOnline",
        },
      ],
    },
    customDimensions: {
      label: "v2_sort_custom_dimensions_label",
      key: "customDimensions",
      childs: [
        {
          label: "v2_sort_cd1_label",
          key: "cd1",
        },
        {
          label: "v2_sort_cd2_label",
          key: "cd2",
        },
        {
          label: "v2_sort_cd3_label",
          key: "cd3",
        },
        {
          label: "v2_sort_cd4_label",
          key: "cd4",
        },
        {
          label: "v2_sort_cd5_label",
          key: "cd5",
        },
      ],
    },
    clickAndBudget: {
      label: "v2_sort_clickAndBudget_label",
      key: "clickAndBudget",
      showParentInLabel: true,
      childs: [
        {
          label: "v2_sort_entire_runtime_label",
          key: "entire_runtime",
        },
        {
          label: "v2_sort_last_30_days_label",
          key: "last_30_days",
        },
        {
          label: "v2_sort_selected_date_range_label",
          key: "selected_date_range",
        },
        {
          label: "v2_sort_selected__this_period_date_range_label",
          key: "selected_this_period",
          parentLabel: false,
        },
        {
          label: "v2_sort_budget_limit_label",
          key: "budget_limit",
          parentLabel: false,
        },
      ],
    },
    synonymsAndLocations: {
      label: "v2_sort_synonymsAndLocations_label",
      key: "synonymsAndLocations",
      childs: [
        {
          label: "v2_sort_total_title_synonyms_label",
          key: "total_title_synonyms",
        },
        {
          label: "v2_sort_total_location_synonyms_label",
          key: "total_location_synonyms",
        },
        {
          label: "v2_sort_total_synonyms_label",
          key: "total_synonyms",
        },
      ],
    },
    startAndEndApplication: {
      label: "v2_sort_startAndEndApplication_label",
      key: "startAndEndApplication",
      childs: [
        {
          label: "v2_sort_start_conversion_label",
          key: "start_conversion",
        },
        {
          label: "v2_sort_end_conversion_label",
          key: "end_conversion",
        },
        {
          label: "v2_sort_start_conversion_rate_label",
          key: "start_conversion_rate",
        },
        {
          label: "v2_sort_end_conversion_rate_label",
          key: "end_conversion_rate",
        },
        {
          label: "v2_sort_cost_per_application_label",
          key: "cost_per_application",
        },
      ],
    },
    jqxAndMarketData: {
      label: "v2_sort_jqxAndMarketData_label",
      key: "jqxAndMarketData",
      showParentInLabel: true,
      childs: [
        {
          label: "v2_sort_jqx_label",
          key: "jqx",
          parentLabel: false,
        },
        {
          label: "v2_sort_vacancy_label",
          key: "vacancy",
          parentLabel: "v2_filter_section_md",
        },
        {
          label: "v2_sort_factor_label",
          key: "factor",
          parentLabel: "v2_filter_section_md",
        },
      ],
    },
  },
  v2_ticket_admin: {
    // newlyAdded: {
    //   label: 'v2_jobs_summary_newly_added_text',
    //   key : 'newlyAdded'

    // },
    basicData: {
      label: "v2_sort_basic_label",
      key: "basicData",
      childs: [
        {
          label: "v2_admin_customer_name_column_label",
          key: "Customer",
        },
        {
          label: "v2_admin_job_title_column_label",
          key: "JobTitle",
        },
        {
          label: "v2_admin_job_keyword_column_label",
          key: "Keyword",
        },
        {
          label: "v2_admin_status_column_label",
          key: "Status",
        },
        {
          label: "v2_admin_mode_column_label",
          key: "AutomaticApproval",
        },
        // {
        //   label: 'v2_ticket_sort_PauseDate_label',
        //   key : 'PauseDate'
        // },
        {
          label: "v2_admin_blocked_column_label",
          key: "LockedByAdmin",
        },
        {
          label: "v2_admin_last_edit_column_label",
          key: "LastUpdate",
        },
        {
          label: "v2_admin_consultant_column_label",
          key: "Consultant",
        },
      ],
    },
  },
};
export const CurrencySymbol = "€";

export const emptyConfig = {
  series: [
    {
      colorByPoint: true,
      innerSize: "75%",
      data: [],
    },
  ],
  centerElement: {
    value: 0,
    label: "Your_key_here",
  },
  height: 192,
  width: 192,
};

export const Separator = "|";
export const ViewsLimit = 100;

export const HelpCenterLinks = {
  default: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  dashboard: {
    de: "https://intercom-help.eu/jobspreader/de/articles/185106-die-kampagne",
    en: "https://intercom-help.eu/jobspreader/en/articles/185106-the-campaign",
  },
  jobs_dashboard: {
    de: "https://intercom-help.eu/jobspreader/de/articles/363401-jobdetails",
    en: "https://intercom-help.eu/jobspreader/en/articles/363401-job-details",
  },
  views_dashboard: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  views: {
    de: "https://intercom-help.eu/jobspreader/de/articles/365825-ansichten",
    en: "https://intercom-help.eu/jobspreader/en/articles/365825-views",
  },
  jobs_listing_recommendations: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_job_status: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_applications: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_job_budget: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_synonyms: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_jqx: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_marketdata: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  jobs_listing_sourcing: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  tickets_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  job_title_checker_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  md_checker_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  innovation_lab_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  ssb_listing: {
    de: "https://intercom-help.eu/jobspreader/de/articles/365155-sourcing-builder",
    en: "https://intercom-help.eu/jobspreader/en/articles/365155-sourcing-builder",
  },
  job_briefing_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  cpi_listing: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  personal_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  configuration_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  user_and_rights_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  notifications_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  job_budget_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  synonyms_automation_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  job_group_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  sea_settings: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
  job_portfolio: {
    de: "https://intercom-help.eu/jobspreader/de/articles/363401-jobdetails",
    en: "https://intercom-help.eu/jobspreader/en/articles/363401-job-details",
  },
  jobs_config: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380814-anpassung-der-jobkarte-und-job-ubersicht",
    en: "https://intercom-help.eu/jobspreader/en/articles/380814-customize-job-card-and-job-overview",
  },
  sourcing_search_builder: {
    de: "https://intercom-help.eu/jobspreader/de/articles/365155-sourcing-builder",
    en: "https://intercom-help.eu/jobspreader/en/articles/365155-sourcing-builder",
  },
  job_briefing: {
    de: "https://intercom-help.eu/jobspreader/de/articles/365137-job-briefing",
    en: "https://intercom-help.eu/jobspreader/en/articles/365137-job-briefing",
  },
  jqx_problems_a1: {
    de: "https://intercom-help.eu/jobspreader/de/articles/185366-der-jobtitle-quality-index-jqx",
    en: "https://intercom-help.eu/jobspreader/en/articles/185366-job-title-quality-index-jqx",
  },
  jqx_problems_a2: {
    de: "https://intercom-help.eu/jobspreader/de/articles/185366-der-jobtitle-quality-index-jqx",
    en: "https://intercom-help.eu/jobspreader/en/articles/185366-job-title-quality-index-jqx",
  },
  myjobs: {
    de: "https://intercom-help.eu/jobspreader/de/articles/380661-jobubersicht-und-jobkarte",
    en: "https://intercom-help.eu/jobspreader/en/articles/380661-job-overview-and-job-card",
  },
  postings_overview: {
    de: "https://intercom-help.eu/jobspreader/de",
    en: "https://intercom-help.eu/jobspreader/en",
  },
};

export const ApplicableTodos = {
  todoAddSynonym: "addSynonyms",
  todoImproveJQX: "improveJQX",
  todoIncreaseBudget: "increaseJobBudget",
};

export const originalColors = {
  1: "#2C72AA",
  2: "#639CC9",
  3: "#8AB5D7",
  4: "#B1CDE4",
  5: "#D8E6F2",

  6: "#B0B4FF",
  7: "#C0C3FF",
  8: "#D0D2FF",
  9: "#E0E1FF",
  10: "#EFF0FF",
};

export const Synonymscolors = {
  1: "#07BEB8",
  2: "#39CBC6",
  3: "#6AD8D4",
  4: "#9CE5E3",
  5: "#CDF2F1",

  6: "#A9D8B8",
  7: "#BAE0C6",
  8: "#CBE8D4",
  9: "#DDEFE3",
  10: "#EEF7F1",
};

export const CDOverviewTabOptions = [
  {
    key: "dashboard",
    label: "v2_dashboard",
  },
  {
    key: "collection",
    label: "v2_collection",
  },
];

export const ColumnsKeysForAddPostings = {
  requestedTitles: "requestedTitles",
  clientTitles: "clientTitles",
  aiTitles: "aiTitles",
  currentTitles: "currentTitles",
};

export const AdminColumns = {
  // priorityCol: {
  //   name: "priorityCol",
  //   label: "v2_admin_priority_column_label",
  //   module: "v2_ticket_admin",
  // },
  
  customerNameCol: {
    name: "customerNameCol",
    label: "v2_admin_customer_name_column_label",
    module: "v2_ticket_admin",
  },
  jobTitleCol: {
    name: "jobTitleCol",
    label: "v2_admin_job_title_column_label",
    module: "v2_ticket_admin",
  },
  jobKeywordCol: {
    name: "jobKeywordCol",
    label: "v2_admin_job_keyword_column_label",
    module: "v2_ticket_admin",
  },
  statusCol: {
    name: "statusColSynonyms",
    label: "v2_admin_status_column_label",
    module: "v2_ticket_admin",
  },
  modeCol: {
    name: "modeCol",
    label: "v2_admin_mode_column_label",
    module: "v2_ticket_admin",
  },
  
  blockedCol: {
    name: "blockedCol",
    label: "v2_admin_blocked_column_label",
    module: "v2_ticket_admin",
  },
  lastEditCol: {
    name: "lastEditCol",
    label: "v2_admin_last_edit_column_label",
    module: "v2_ticket_admin",
  },
  consultantCol: {
    name: "consultantCol",
    label: "v2_admin_consultant_column_label",
    module: "v2_ticket_admin",
  },
};



export const JQXWarningThreshold = 70;

export const SSBSortOptions = {
  basicData: {
    label: "v2_sort_basic_label",
    key: "basicData",
    children: [
      { label: "pf_ssb_name_txt", value: "basicData-title", headerCol: "statusCol" },
      { label: "pf_ssb_search_txt", value: "searchesSSB", headerCol: "statusCol" },
      { label: "labs_jb_step1_s_location", value: "basicData-location", headerCol: "locationCol" },
      { label: "v2_jobs_tabs_head_2", value: "basicData-jobStatus", headerCol: "statusCol" },
      { label: "v2_sort_onlineDate_label", value: "basicData-onlineDate", headerCol: "onlineOfflineColSynonyms" },
      { label: "v2_sort_offlineDate_label", value: "basicData-offlineDate", headerCol: "offlineDate" },
      { label: "v2_sort_daysOnline_label", value: "basicData-daysOnline", headerCol: "daysOnline" },
    ],
  },
  customDimensions: {
    label: "v2_sort_custom_dimensions_label",
    key: "customDimensions",
    children: [],
  },
};
